var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 66,
    viewBox: "0 0 62 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 33C14.7866 33 14.2083 33.6156 14.2083 34.375V55H10.3333V9.625H7.75V56.375C7.75 57.1344 8.32831 57.75 9.04167 57.75H52.9583V55H50.375V17.875C50.375 17.1156 49.7967 16.5 49.0833 16.5H41.3333C40.6199 16.5 40.0417 17.1156 40.0417 17.875V55H37.4583V28.875C37.4583 28.1156 36.8801 27.5 36.1667 27.5H28.4167C27.7033 27.5 27.125 28.1156 27.125 28.875V55H24.5417V34.375C24.5417 33.6156 23.9634 33 23.25 33H15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightAdmin);
export default __webpack_public_path__ + "static/media/insight-admin.de5854356f1ea3bc941339b15952ab26.svg";
export { ForwardRef as ReactComponent };